import script from "./AuthLogsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLogsView.vue?vue&type=script&setup=true&lang=js"

import "./AuthLogsView.vue?vue&type=style&index=0&id=28e94bbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28e94bbc"]])

export default __exports__